<template>
  <BasePopup
    :visible="visible"
    :mask-closable="true"
    :show-close-btn="false"
    :show-confirm-btn="false"
    popup-class="v3-tip-popup"
    @close="handleClose"
  >
    <div class="tip-content">
      <div class="tip-title"></div>
      <div class="tip-message">{{ message }}</div>
      <div class="tip-confirm-btn" @click="handleClose"></div>
    </div>
  </BasePopup>
</template>

<script setup>
import { watch } from "vue";
import { point } from "@/utils";
import BasePopup from './BasePopup.vue';

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  message: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['close', 'update:visible']);

// 监听弹窗状态，打点上报
watch(
  () => props.visible,
  (value) => {
    if (value) {
      point({
        eventName: 'show_popup',
        eventType: '提示弹窗'
      });
    }
  }
);

const handleClose = () => {
  emit('close');
  emit('update:visible', false);
};
</script>

<style scoped lang="less">
/* 样式在全局 popup.less 文件中定义 */
</style>
